import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentLoaderService } from './environment-loader.service';
import { Observable } from 'rxjs';
import { PagedResult } from '../models/paging';
import { ActionLog, EntityType } from 'src/app/features/prices/action-log';

@Injectable({
  providedIn: 'root',
})
export class ActionLogService {
  private httpClient = inject(HttpClient);

  private readonly apiUrl: string;
  private readonly httpHeaders: HttpHeaders;

  constructor() {
    const environmentService = inject(EnvironmentLoaderService);

    this.apiUrl = environmentService.config.serviceBaseUrl + '/api/v1/admin';

    this.httpHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin': this.apiUrl,
      'Content-Type': 'application/json',
    });
  }

  public getActionLogs(
    organizationId: number | null,
    pageSize: number,
    pageIndex: number,
    entityType?: EntityType,
    entityId?: number | null
  ): Observable<PagedResult<ActionLog>> {
    const url = `${this.apiUrl}/ActionLog/`;
    let params = new HttpParams();

    if (organizationId) {
      params = params.append('organizationId', organizationId);
    }
    if (pageSize != null) {
      params = params.append('pageSize', pageSize);
    }
    if (pageIndex) {
      params = params.append('page', pageIndex);
    }
    if (entityType) {
      params = params.append('entityType', entityType);
    }
    if (entityId) {
      params = params.append('entityId', entityId);
    }

    return this.httpClient.get<PagedResult<ActionLog>>(url, {
      params,
    });
  }
}
